import { detect } from "detect-browser";
import propTypes from "prop-types";
const browser = detect();

const ValidBrowser = ({ test, valid, error }) =>
  test(browser) ? valid : error;

ValidBrowser.propTypes = {
  test: propTypes.func.isRequired,
  valid: propTypes.element.isRequired,
  error: propTypes.element.isRequired
};

export default ValidBrowser;
